import { Button } from '@/components/ui/button';

// Themed fallback shown by the Sentry ErrorBoundary when a render error escapes.
export function ErrorFallback({ resetError }: { resetError: () => void }) {
  return (
    <div className="bg-background text-foreground flex min-h-screen flex-col items-center justify-center gap-4">
      <h1 className="text-2xl font-semibold">Something went wrong</h1>
      <p className="text-muted-foreground">An unexpected error occurred.</p>
      <div className="flex gap-3">
        <Button onClick={resetError}>Try again</Button>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Reload
        </Button>
      </div>
    </div>
  );
}
